<div class="issue-container">
  <div class="issue-topbar">
    <div class="topbar-left">
      <h1>
        Issue Stock
        <small>Consumables only — they go to Issued Stock and are not returned. Rentables go out through Issue Equipment.</small>
      </h1>
      <div class="breadcrumb">
        <i class="bi bi-house-door"></i> IMS / <span>Inventory</span> / <span class="current">Issue Stock</span>
        <span class="separator">|</span>
        <span class="time"><i class="bi bi-clock"></i> {{ timestamp() }}</span>
      </div>
    </div>
    <div class="topbar-right">
      <a class="btn btn-outline btn-sm" routerLink="/issued-stock">
        <i class="bi bi-journal-text"></i> Issued Stock
      </a>
      <button class="btn btn-outline btn-sm" type="button" (click)="exportData()">
        <i class="bi bi-download"></i> Export
      </button>
    </div>
  </div>

  <div class="issue-form">
    <div class="form-card">
      <h3><i class="bi bi-info-circle"></i> Recipient and source</h3>
      <div class="form-row">
        <div class="form-group">
          <label>Recipient name <span class="required">*</span></label>
          <input type="text" placeholder="Person the items are issued to..." [ngModel]="issuedToCase()" (ngModelChange)="issuedToCase.set($event)" />
        </div>
        <div class="form-group">
          <label>Cell number <span class="required">*</span></label>
          <input type="tel" placeholder="Recipient cell number..." appPhoneOnly [ngModel]="recipientPhone()" (ngModelChange)="recipientPhone.set($event)" />
        </div>
      </div>
      <div class="form-row">
        <div class="form-group">
          <label>Recipient location <span class="required">*</span></label>
          <input type="text" placeholder="Where the person is receiving the items..." [ngModel]="recipientLocation()" (ngModelChange)="recipientLocation.set($event)" />
        </div>
        <div class="form-group">
          <label>Issue Date <span class="required">*</span></label>
          <input type="date" [ngModel]="issueDate()" (ngModelChange)="issueDate.set($event)" />
        </div>
      </div>
      <div class="form-row">
        <div class="form-group">
          <label>Issued By <span class="required">*</span></label>
          <input type="text" [ngModel]="issuedBy()" readonly />
        </div>
        <div class="form-group">
          <label>Take stock from branch <span class="required">*</span></label>
          <select [ngModel]="branchId()" (ngModelChange)="onBranchChange($event)" [disabled]="branchSelectionLocked()">
            <option value="">Select branch</option>
            @for (branch of branches(); track branch.id) {
              <option [value]="branch.id">{{ branch.name }}</option>
            }
          </select>
        </div>
      </div>
      <div class="form-row">
        <div class="form-group">
          <label>Store location <span class="required">*</span></label>
          <select [ngModel]="locationId()" (ngModelChange)="onLocationChange($event)" [disabled]="!branchId()">
            <option value="">Select store location</option>
            @for (location of locationsForBranch(); track location.id) {
              <option [value]="location.id">{{ location.name }}</option>
            }
          </select>
        </div>
        <div class="form-group">
          <label>Notes</label>
          <textarea rows="2" placeholder="Add any additional notes about this issuance..." [ngModel]="notes()" (ngModelChange)="notes.set($event)"></textarea>
        </div>
      </div>
    </div>

    <div class="form-card">
      <div class="card-header-actions">
        <h3><i class="bi bi-box-seam"></i> Items to Issue</h3>
        <button class="btn btn-outline btn-sm" (click)="openItemModal()">
          <i class="bi bi-plus-circle"></i> Add Item
        </button>
      </div>

      <div class="table-wrap">
        <div class="table-scroll">
          <table>
            <thead>
              <tr>
                <th>Item</th>
                <th>Category</th>
                <th>Unit Price</th>
                <th>Available</th>
                <th>Qty to Issue</th>
                <th>Line Total</th>
                <th>Reserved</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              @for (line of lineItems(); track line.itemId) {
                <tr>
                  <td>
                    <div class="item-info">
                      <span class="item-icon"><i class="bi" [class]="line.icon || 'bi-box-seam'"></i></span>
                      <div>
                        <div class="item-name">{{ line.name }}</div>
                        <div class="item-code">{{ line.code }}</div>
                      </div>
                    </div>
                  </td>
                  <td>{{ line.category }}</td>
                  <td>
                    <input
                      type="number"
                      class="price-input"
                      min="0"
                      step="0.01"
                      appDecimalOnly
                      [ngModel]="line.price"
                      (ngModelChange)="updateLinePrice(line.itemId, $event)"
                    />
                  </td>
                  <td><span class="stock-available" [class.low]="line.available <= 10">{{ line.available }}</span></td>
                  <td>
                    <input type="number" class="qty-input" min="1" step="1" appDigitsOnly [ngModel]="line.quantity" (ngModelChange)="updateLineQuantity(line.itemId, $event)" />
                  </td>
                  <td>{{ formatCurrency(line.quantity * line.price) }}</td>
                  <td>
                    <label class="switch">
                      <input type="checkbox" [ngModel]="line.reserved" (ngModelChange)="toggleReserved(line.itemId, $event)" />
                      <span class="slider"></span>
                    </label>
                  </td>
                  <td class="actions-cell">
                    <button
                      type="button"
                      class="btn-action delete"
                      title="Remove item"
                      (click)="removeLineItem(line.itemId)"
                    >
                      <i class="bi bi-trash"></i>
                    </button>
                  </td>
                </tr>
              } @empty {
                <tr>
                  <td colspan="8" class="empty-cell">No items added yet. Click Add Item to start.</td>
                </tr>
              }
            </tbody>
          </table>
        </div>
      </div>

      <div class="summary-row">
        <div class="summary-item">
          <span class="summary-label">Total Items</span>
          <span class="summary-value">{{ totalItems() }}</span>
        </div>
        <div class="summary-item">
          <span class="summary-label">Total Quantity</span>
          <span class="summary-value">{{ totalQuantity() }}</span>
        </div>
        <div class="summary-item">
          <span class="summary-label">Reserved Items</span>
          <span class="summary-value">{{ reservedCount() }}</span>
        </div>
        <div class="summary-item">
          <span class="summary-label">Issue Value</span>
          <span class="summary-value">{{ formatCurrency(estimatedValue()) }}</span>
        </div>
      </div>

      <div class="form-actions">
        <button class="btn btn-outline" type="button" (click)="resetForm()">Cancel</button>
        <button class="btn btn-primary" type="button" (click)="openConfirmModal()" [disabled]="submitting()">
          <i class="bi bi-check-lg"></i> {{ submitting() ? 'Issuing…' : 'Issue / Reserve' }}
        </button>
      </div>
    </div>
  </div>

  <div class="form-card recent-issues-card">
    <div class="card-header-actions">
      <h3><i class="bi bi-clock-history"></i> Recent Issues &amp; Reserves</h3>
    </div>

    <div class="table-wrap">
      <div class="table-scroll">
        <table>
          <thead>
            <tr>
              <th>Issue No.</th>
              <th>Issued To</th>
              <th>Cell</th>
              <th>Destination</th>
              <th>Item</th>
              <th>Branch</th>
              <th>Qty</th>
              <th>Date</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            @for (issue of issueStockList().slice(0, 12); track issue.id) {
              <tr>
                <td><span class="issue-id">{{ issue.issueNumber }}</span></td>
                <td>{{ issue.issuedTo }}</td>
                <td>{{ issue.recipientPhone || '—' }}</td>
                <td>{{ issue.recipientLocation || '—' }}</td>
                <td>{{ issue.itemName || '—' }}</td>
                <td>{{ issue.branch }}</td>
                <td>{{ issue.items }}</td>
                <td>{{ formatDate(issue.issueDate) }}</td>
                <td>
                  <span
                    class="status-badge"
                    [class.pending]="issue.status === 'pending'"
                    [class.reserved]="issue.status === 'reserved'"
                    [class.issued]="issue.status === 'issued'"
                    [class.cancelled]="issue.status === 'cancelled'"
                  >{{ issueStatusLabel(issue.status) }}</span>
                </td>
                <td class="actions-cell">
                  <div class="row-actions">
                    @if (issue.status === 'reserved' || issue.isReservedHold) {
                      <button
                        type="button"
                        class="btn-action complete"
                        title="Issue reserved stock now"
                        (click)="issueReservedHold(issue)"
                        [disabled]="submitting()"
                      >
                        <i class="bi bi-box-arrow-up"></i>
                      </button>
                      <button
                        type="button"
                        class="btn-action cancel"
                        title="Release reserved hold"
                        (click)="releaseReservedHold(issue)"
                        [disabled]="submitting()"
                      >
                        <i class="bi bi-unlock"></i>
                      </button>
                    } @else {
                      <button type="button" class="btn-action edit" title="Edit issue" (click)="openEditIssueModal(issue)">
                        <i class="bi bi-pencil"></i>
                      </button>
                    }
                  </div>
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>

<!-- Add Item Modal -->
<div class="modal-overlay" [class.open]="showItemModal()" (click)="closeModalOnBackdrop($event)">
  <div class="modal">
    <div class="modal-header">
      <h2><i class="bi bi-plus-circle"></i> Add Stock Item</h2>
      <button class="close-btn" (click)="closeItemModal()">
        <i class="bi bi-x-lg"></i>
      </button>
    </div>

    <div class="modal-body">
      <div class="form-row">
        <div class="form-group full">
          <label>Search Item <span class="required">*</span></label>
          <input type="text" placeholder="Type to search items..." [ngModel]="itemSearch()" (ngModelChange)="itemSearch.set($event)" />
        </div>
      </div>

      <div class="item-search-results">
        @for (item of filteredPickerItems(); track item.id) {
          <div
            class="search-result-item"
            [class.selected]="selectedItemId() === item.id"
            [class.disabled]="!item.canIssue"
            (click)="selectItem(item)"
          >
            <div class="result-info">
              <span class="result-icon"><i class="bi" [class]="item.icon || 'bi-box-seam'"></i></span>
              <div>
                <div class="result-name">{{ item.name }}</div>
                <div class="result-code">{{ item.code }}</div>
                @if (!item.canIssue) {
                  <div class="result-code stock-suggestion">{{ item.unavailableReason }}</div>
                }
              </div>
            </div>
            <span class="result-stock" [class.low]="item.available <= 10">
              {{ item.canIssue ? item.available + ' available' : 'Unavailable' }}
            </span>
          </div>
        }
      </div>
    </div>

    <div class="modal-footer">
      <button class="btn btn-outline" (click)="closeItemModal()">Cancel</button>
      <button class="btn btn-primary" (click)="addSelectedItem()" [disabled]="!selectedItemId()">
        <i class="bi bi-check-lg"></i> Add Selected
      </button>
    </div>
  </div>
</div>

<!-- Edit Issue Modal -->
<div class="modal-overlay" [class.open]="showEditIssueModal()" (click)="closeModalOnBackdrop($event)">
  <div class="modal">
    <div class="modal-header">
      <h2><i class="bi bi-pencil"></i> Edit Stock Issue</h2>
      <button class="close-btn" (click)="closeEditIssueModal()">
        <i class="bi bi-x-lg"></i>
      </button>
    </div>

    <div class="modal-body">
      <div class="form-row">
        <div class="form-group">
          <label>Issued To <span class="required">*</span></label>
          <input type="text" [ngModel]="editIssue().issuedTo" (ngModelChange)="updateEditIssue('issuedTo', $event)" />
        </div>
        <div class="form-group">
          <label>Branch <span class="required">*</span></label>
          <select [ngModel]="editIssue().branch" (ngModelChange)="updateEditIssue('branch', $event)">
            <option value="">Select Branch</option>
            @for (branch of branches(); track branch.id) {
              <option [value]="branch.id">{{ branch.name }}</option>
            }
          </select>
        </div>
      </div>

      <div class="form-row">
        <div class="form-group">
          <label>Issue Date <span class="required">*</span></label>
          <input type="date" [ngModel]="editIssue().issueDate" (ngModelChange)="updateEditIssue('issueDate', $event)" />
        </div>
        <div class="form-group">
          <label>Items Count <span class="required">*</span></label>
          <input type="number" min="1" step="1" appDigitsOnly [ngModel]="editIssue().items" (ngModelChange)="updateEditIssue('items', $event)" />
        </div>
      </div>

      <div class="form-row">
        <div class="form-group">
          <label>Status <span class="required">*</span></label>
          <select [ngModel]="editIssue().status" (ngModelChange)="updateEditIssue('status', $event)">
            <option value="pending">Pending</option>
            <option value="reserved">Reserved</option>
            <option value="issued">Issued</option>
            <option value="cancelled">Cancelled</option>
          </select>
        </div>
      </div>
    </div>

    <div class="modal-footer">
      <button class="btn btn-outline" type="button" (click)="closeEditIssueModal()" [disabled]="saving()">Cancel</button>
      <button class="btn btn-primary" type="button" (click)="submitEditIssue()" [disabled]="saving()">
        <i class="bi bi-check-lg"></i> {{ saving() ? 'Saving…' : 'Save Changes' }}
      </button>
    </div>
  </div>
</div>

<!-- Confirm Issue Modal -->
<div class="modal-overlay" [class.open]="showConfirmModal()" (click)="closeModalOnBackdrop($event)">
  <div class="modal confirm-modal">
    <div class="modal-header">
      <h2><i class="bi bi-check-circle" style="color: #10b981;"></i> Confirm Issue</h2>
      <button class="close-btn" (click)="closeConfirmModal()">
        <i class="bi bi-x-lg"></i>
      </button>
    </div>

    <div class="modal-body">
      <div class="confirm-icon">
        <i class="bi bi-box-seam"></i>
      </div>
      <p class="confirm-text">Are you sure you want to issue these items?</p>
      <p class="confirm-subtext">
        @if (consumableIssuedCount() > 0) {
          <span>{{ consumableIssuedCount() }} consumable line{{ consumableIssuedCount() === 1 ? '' : 's' }} go to Issued Stock and are not returned.</span>
        }
        @if (reservedCount() > 0) {
          <span>Reserved lines appear under Recent Issues &amp; Reserves — click Issue now when ready.</span>
        }
      </p>

      <div class="confirm-details">
        <div class="confirm-row">
          <span class="confirm-label">Recipient:</span>
          <span class="confirm-value">{{ issuedToCase() }} · {{ recipientPhone() }} · {{ recipientLocation() }}</span>
        </div>
        <div class="confirm-row">
          <span class="confirm-label">Taken from:</span>
          <span class="confirm-value">{{ selectedBranchName() }} / {{ selectedLocationName() }}</span>
        </div>
        <div class="confirm-row">
          <span class="confirm-label">Total Items:</span>
          <span class="confirm-value">{{ totalItems() }}</span>
        </div>
        <div class="confirm-row">
          <span class="confirm-label">Total Quantity:</span>
          <span class="confirm-value">{{ totalQuantity() }}</span>
        </div>
        <div class="confirm-row">
          <span class="confirm-label">Issue Value:</span>
          <span class="confirm-value">{{ formatCurrency(estimatedValue()) }}</span>
        </div>
      </div>

      <div class="confirm-items">
        @for (line of lineItems(); track line.itemId) {
          <div class="confirm-item">
            <span class="confirm-item-name">
              {{ line.name }}{{ line.reserved ? ' (reserve)' : '' }}
            </span>
            <span class="confirm-item-meta">
              {{ formatCurrency(line.price) }} × {{ line.quantity }} = {{ formatCurrency(line.quantity * line.price) }}
            </span>
          </div>
        }
      </div>
    </div>

    <div class="modal-footer">
      <button class="btn btn-outline" type="button" (click)="closeConfirmModal()" [disabled]="submitting()">Cancel</button>
      <button class="btn btn-success" type="button" (click)="confirmIssue()" [disabled]="submitting()">
        <i class="bi bi-check-lg"></i> {{ submitting() ? 'Issuing…' : 'Confirm Issue' }}
      </button>
    </div>
  </div>
</div>

<!-- Toast -->
<div class="toast-container" [class.show]="showToast()">
  <div class="toast" [class.success]="toastType() === 'success'" [class.error]="toastType() === 'error'" [class.info]="toastType() === 'info'">
    <div class="toast-icon">
      @if (toastType() === 'error') {
        <i class="bi bi-exclamation-circle-fill"></i>
      } @else if (toastType() === 'info') {
        <i class="bi bi-info-circle-fill"></i>
      } @else {
        <i class="bi bi-check-circle-fill"></i>
      }
    </div>
    <div class="toast-content">
      <div class="toast-title">
        @if (toastType() === 'error') {
          Error
        } @else if (toastType() === 'info') {
          Notice
        } @else {
          Success!
        }
      </div>
      <div class="toast-message">{{ toastMessage() }}</div>
    </div>
    <button class="toast-close" (click)="closeToast()">
      <i class="bi bi-x-lg"></i>
    </button>
  </div>
</div>
